import React, { useState, useEffect } from 'react';
import axiosInstance from "../../../interceptor/axiosInstance";
import NotificationService from "../../Utils/NotificationService";

const WordPressElementorGuide = () => {
  const [orgCode, setOrgCode] = useState('');
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const fetchOrgDetails = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setOrgCode("YOUR_ORG_CODE");
        return;
      }
      try {
        const response = await axiosInstance.get(`/org/org-details`);
        const data = response.data[0];
        setOrgCode(data.organisation_code);
      } catch (error) {
        console.error('Error fetching organization details:', error);
        setOrgCode("YOUR_ORG_CODE");
      }
    };
    fetchOrgDetails();
  }, []);

  const fullCode = `<div id="chat-bot-container"></div>\n<script src="https://ezzdesk.com/shared_prompt.js?code=${orgCode}"></script>`;

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }).catch((err) => {
      NotificationService.error('Failed to copy text: ' + err);
    });
  };

  const ImagePlaceholder = () => (
    <div style={{
      width: '100%',
      height: '300px',
      backgroundColor: '#f0f0f0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '2px dashed #ccc',
      borderRadius: '8px',
      margin: '20px 0',
      color: '#999',
      fontSize: '18px'
    }}>
      Image Placeholder
    </div>
  );

  return (
    <div style={{
      padding: '40px',
      maxWidth: '800px',
      margin: '0 auto',
      fontFamily: 'Arial, sans-serif',
      background: '#ffffff',
      color: '#333',
      lineHeight: '1.6'
    }}>
      <h1 style={{ fontSize: '28px', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
        Adding Ezzdesk Widget to WordPress Website with Elementor
      </h1>
      
      <p style={{ fontSize: '16px', marginBottom: '30px', color: '#555' }}>
        To add an Ezzdesk widget to your site’s page using the Elementor page builder, you’ll first need your widget installation code. In this guide, we’ll walk you through how to install your widget on a specific page of your website. Let’s get started!
      </p>

      <div style={{ marginBottom: '40px' }}>
        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px' }}>
          <strong>1. Choose a page</strong><br/>
          Log in to your WordPress website’s backend, navigate to <strong>Pages</strong>, and select the page where you’d like to add the widget:
        </p>
        <img src="/assets/elementer-1.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>2. Open Elementor editor</strong><br/>
          Click <strong>Edit with Elementor</strong> to start working on your page:
        </p>
        <img src="/assets/elementer-2.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>3. Add HTML element</strong><br/>
          Locate the spot on the page where you want to place the widget. Then, find the <strong>HTML</strong> element in the sidebar and drag it onto the page:
        </p>
        <img src="/assets/elementer-3.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <div style={{ background: '#fff3cd', borderLeft: '4px solid #ffecb5', padding: '10px', marginBottom: '20px', fontSize: '14px' }}>
          <strong>Note:</strong> Make sure to select the <strong>HTML</strong> element. Avoid selecting the <strong>Custom HTML</strong> element, as this may prevent the widget from displaying correctly.
        </div>

        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          <strong>4. Add your widget installation code</strong><br/>
          Next, paste the installation code into the <strong>HTML Code</strong> box, and your widget will appear on the page:
        </p>
        
        <div style={{ position: 'relative', marginBottom: '20px' }}>
          <pre style={{ background: '#f4f4f4', padding: '20px', border: '1px solid #ddd', borderRadius: '5px', fontFamily: 'Courier New, monospace', fontSize: '14px', overflowX: 'auto' }}>
            {fullCode}
          </pre>
          <button onClick={() => handleCopy(fullCode)} className='btn-color' style={{ position: 'absolute', top: '15px', right: '15px', padding: '6px 16px', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold' }}>
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <img src="/assets/elementer-4.png" alt="Paste Code" style={{ maxWidth: '100%', borderRadius: '8px', border: '1px solid #ddd', margin: '15px 0' }} />


        <p style={{ fontSize: '15px', color: '#666', marginBottom: '10px', marginTop: '20px' }}>
          Don't forget to <strong>Publish</strong> the changes. 😉 You have successfully installed your widget!
        </p>
      </div>

    </div>
  );
};

export default WordPressElementorGuide;
